<template>
  <b-modal
    ref="modal"
    title="Nuovo documento"
    centered
    body-class="p-0"
    no-close-on-backdrop
  >

    <div
      role="group"
      class="col-12 stack-label"
    >
      <label>Seleziona tipo istanza</label>
      <b-form-select
        v-model="tipo"
        :options="tipoIstanzaOptions"
        size="sm"
      />
    </div>

    <div
      role="group"
      class="col-12 stack-label"
    >
      <label>Unità immobiliare</label>
      <div>{{codiceUibOptions.text}}</div>
    </div>

    <template slot="modal-footer">
      <b-button
        variant="success"
        :disabled="!canSubmit"
        @click="addNew"
      >
        <font-awesome-icon icon="plus" /> Aggiungi
      </b-button>

      <b-button
        variant="outline-secondary"
        @click="close"
      >
        <font-awesome-icon icon="times" /> Chiudi
      </b-button>
    </template>

  </b-modal>
</template>

<script>
export default {
  name: 'NuovaIstanzaModal',
  data () {
    return {
      tipo: '',
      codiceUib: '',
      codiceUibOptions: {}
    }
  },

  computed: {
    tipoIstanzaOptions () {
      return this.$store.state.options.tipoIstanza
    },
    canSubmit () {
      return this.tipo && this.codiceUib
    }
  },

  methods: {

    async open () {
      this.tipo = ''
      this.codiceUib = ''
      await Promise.all([
        this.$store.dispatch('options/loadTipoIstanzaOptions'),
        this.$store.dispatch('options/loadUnitaImmobiliareOptions')
      ])
      this.codiceUib = (this.$store.state.options.unitaImmobiliare ? this.$store.state.options.unitaImmobiliare[0] : {}).value
      this.codiceUibOptions = (this.$store.state.options.unitaImmobiliare ? this.$store.state.options.unitaImmobiliare[0] : {})
      // console.log('Valori caricati alla OPEN', this.$store.state.options.unitaImmobiliare, this.codiceUib)
      this.$refs.modal.show()
    },

    close () {
      this.$refs.modal.hide()
    },

    // codiceUibOptions () {
    //   let immobile = this.$store.state.options.unitaImmobiliare.lenght > 0 ? this.$store.state.options.unitaImmobiliare[0] : {}
    //   // this.codiceUib = immobile.value
    //   console.log('elenco delle altre unità immobiliari', Array.isArray(this.$store.state.options.unitaImmobiliare), this.$store.state.options.unitaImmobiliare, immobile)
    //   return immobile
    // },

    async addNew () {
      try {
        let rs = await this.$store.dispatch('istanze/addNew', { tipoIstanza: this.tipo, codiceUib: this.codiceUib })
        this.close()
        this.$router.push({ name: 'istanza', params: { id: rs.id } })
      } catch (err) {
        this.$ui.showError(err)
        // Se c'è qualsiasi tipo di problema nel caricamento della lista delle dichiarazioni esce comunque.
        this.$router.push({ name: 'home' })
      }
    }
  }
}
</script>
